import { phoneLogin } from 'api/consult'
import qs from 'qs'

export default {
  methods: {
    loginStatus(phone, validcode) {
      let loading = this.$loading('登录中...')
      return new Promise((resolve, reject) => {
        const { channel_flag } = this.$route.query
        phoneLogin(
          qs.stringify({
            phone,
            validcode,
            areacode: '',
            laiyuan: channel_flag
          })
        )
          .then(res => {
            loading.close()
            if (res.code === 0) {
              this.$toast('登录成功')
              return resolve(res)
            } else {
              this.$toast(res.message || '登录失败')
            }
            return reject(res)
          })
          .catch(e => {
            console.log(e)
            loading.close()
            reject(e)
          })
      })
    }
  }
}
